import React, {useRef, useState, RefObject, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from 'modules';
import useHover from 'hooks/useHover';
import {getWidth} from 'lib/utils';
import Volume from 'components/player/controlbar/Volume';

let mouseDown = false; // mousedown 여부
let currentVolume = 0; // 현재 볼륨

/**
 * 컨트롤 바 > 볼륨 컨테이너
 */
const VolumeContainer = () => {
  const {videoDOM} = useSelector((state: RootState) => ({
    videoDOM: state.video.videoDOM,
  }));
  // const videoDOM = document.getElementById("video") as HTMLVideoElement;
  const volumeSliderWrapRef = useRef<HTMLDivElement>(null);
  const [volumeRef, isHoverd] = useHover();
  const [slider, setSlider] = useState({
    percent: 0,
    cssClass: '',
  });
  // const [mouseDown, setMouseDown] = useState(false);
  const [barShow, setBarShow] = useState('');

  /**
   * 볼륨 바 마우스hover 끝나면 2초 후에 사라짐
   */
  useEffect(() => {
    setBarShow('bar_show');

    if (mouseDown) return;

    const timer = setTimeout(() => setBarShow(''), 2000);
    return () => {
      clearTimeout(timer);
    };
  }, [isHoverd]);

  /**
   * 최초 진입 시에는 50% 반값으로 볼륨 설정
   */
  useEffect(() => {
    setVolume(0.5);
  }, []);

  /**
   * 마우스 볼륨 핸들러
   * @param e
   * @param ref
   */
  const getVolumeByHandler = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    ref: RefObject<HTMLDivElement>,
  ): number => {
    if (!ref.current) return -1;
    const sliderWidth = getWidth(ref.current);
    const currentX = e.pageX - ref.current.getBoundingClientRect().left;
    let volume = currentX / sliderWidth;

    volume = Math.max(Math.min(1, volume), 0);

    return volume;
  };

  /**
   * Video tag에 volume 설정 함수
   * @param value 볼륨 값
   */
  const setVideoVolume = (value: number) => {
    if (!videoDOM) return;

    value = Math.min(value, 1);
    value = Math.max(0, value);

    // if (0 < value && video.muted) {

    // }
    videoDOM.volume = value;
  };

  /**
   * 볼륨 슬라이더 움직일 때 그릴 CSS 퍼센트 값 계산
   */
  const moveVolumeSlider = (volume: number): number => {
    let volumeCss: number = volume * 100;
    volumeCss = Math.max(Math.min(100, volumeCss), 0);

    return volumeCss;
  };

  /**
   * 볼륨 셋팅
   * @param volume 미디어 볼륨
   * @param isSoundBtn 사운드 아이콘 클릭 여부
   */
  const setVolume = (volume: number, isSoundBtn = false) => {
    setVideoVolume(volume);
    const volumeCss = moveVolumeSlider(volume);

    let className = '';
    if (volume <= 0) {
      className = 'mute';
    } else if (volume <= 0.5) {
      className = 'small';
    }

    setSlider({
      percent: volumeCss,
      cssClass: className,
    });

    if (!isSoundBtn && volume > 0) {
      // 사운드 버튼 누르면 바로 음소거 처리하고, 음소거 버튼을 누르면 이전 볼륨 값으로 이동
      currentVolume = volume; // 현재 볼륨 저장
    }
  };

  // 볼륨 슬라이더 마우스 클릭 했을 경우
  const onMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    // setMouseDown(true);

    mouseDown = true;
    const volume = getVolumeByHandler(e, volumeSliderWrapRef);

    if (volume !== -1) {
      setVolume(volume);
    }
  };
  /**
   * 볼륨 슬라이더 영역 마우스 움직였을 때 셋팅
   */
  const onMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!mouseDown) return;

    const volume = getVolumeByHandler(e, volumeSliderWrapRef);
    if (volume !== -1) {
      setVolume(volume);
    }
  };
  // 볼륨 슬라이더 마우스 뗏을 경우
  const onMouseUp = () => {
    // setMouseDown(false);
    mouseDown = false;
  };
  // 볼륨 슬라이더 영역에서 마우스 벗어 났을 경우
  const onMouseLeave = () => {
    // setMouseDown(false);
    mouseDown = false;
  };

  /**
   * 사운드 버튼 클릭 함수
   */
  const onClickSound = () => {
    if (!videoDOM) return;

    if (slider.cssClass === 'mute') {
      setVolume(currentVolume, true);
    } else {
      setVolume(0, true);
    }
  };

  return (
    <Volume
      volumeRef={volumeRef}
      volumeSliderWrapRef={volumeSliderWrapRef}
      barShow={barShow}
      slider={slider}
      onMouseMove={onMouseMove}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
      onClickSound={onClickSound}
    />
  );
};

export default VolumeContainer;
